import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import defaultImg from '../../../images/payment/logo.png';

import styles from './Value.css';


const imgStyle = { marginRight: '5px', maxWidth: '34px' };

class Value extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    value: PropTypes.object,
  };

  static defaultProps = {
    children: null,
    value: undefined,
  };

  constructor(...args) {
    super(...args);

    const { value } = this.props;

    this.importImage(value);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.value.value !== this.props.value.value) {
      this.importImage(nextProps.value);
    }
  }

  importImage = (value) => {
    try {
      if (value.cryptoData) {
        this.imgSrc = require(`images/payment/crypto/${value.cryptoData.currency}.png`);
      } else {
        this.imgSrc = require(`images/payment/${value.processorId}_${value.value}.jpg`);
      }
    } catch (err) {
      this.imgSrc = defaultImg;
    }
  };

  render() {
    const { children } = this.props;

    return (
      <div className={styles.container}>
        <img
          alt=""
          height="18px"
          src={this.imgSrc}
          style={imgStyle}
        />
        {children}
      </div>
    );
  }
}

export default Value;
